export default __webpack_public_path__ + "static/media/index.1b1cb7c5.less";